<template>
  <div class="backstage-index">
    <div class="head">
      <!-- 布局头部导航栏 -->
      <page-head @loginOut="loginOut"/>
    </div>
    <div class="layout">
      <!-- 布局侧边栏 -->
      <div class="aside">
        <!-- 布局导航栏 -->
        <div class="menu">
          <menu-Layout :menuList="menuList" :isLevelAdmin="isLevelAdmin" />
        </div>
      </div>
      <div class="right-layout">
        <!-- 面包屑 -->
        <div class="bread-crumb">
          <bread-crumb />
        </div>
        <!-- 顶部导航 -->
        <div class="top-menu" v-show="isShowTopMenu">
          <top-menu />
        </div>
        <!-- 内容区 -->
        <div id="content" class="content">
          <div class="main">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Common from '@/models/common/common'
import PageHead from "@/components/layout/page-head";
import BreadCrumb from "@/components/layout/bread-crumb";
import MenuLayout from "@/components/layout/Menu";
import TopMenu from "@/components/layout/top-menu";
import { config } from '@/common/js/config.js'
import { deleteToken, deleteAdminType, deleteUserName, deleteIsAdmin, deleteTeamId } from "@/common/js/storage";
export default {
  components: {
    PageHead,
    MenuLayout,
    BreadCrumb,
    TopMenu
  },

  data() {
    return {
      menuList: [
        {
          name: "系统设置",
          url: "/oneLevel/systemIndex",
          img: require('../../assets/menu/system-settings.png'),
          children: [
            {
              name: "成员与部门",
              url: "/oneLevel/systemIndex/staffDepartmentIndex/staff",
              commonUrl: '/oneLevel/systemIndex/staffDepartmentIndex',
            },
            {
              name: "系统管理员",
              url: "/oneLevel/systemIndex/roleAuthority",
              commonUrl: '/oneLevel/systemIndex/roleAuthority',
            }
          ]
        },
        {
          name: "风险模块",
          url: "/oneLevel/riskModuleIndex",
          img: require('../../assets/menu/risk.png'),
          children: [
            {
              name: "风险设置",
              url: "/oneLevel/riskModuleIndex/riskWarnIndex/riskWarn",
              commonUrl: '/oneLevel/riskModuleIndex/riskWarnIndex',
            },
            {
              name: "预警发布",
              url: "/oneLevel/riskModuleIndex/riskReleaseIndex/riskReleaseList",
              commonUrl: '/oneLevel/riskModuleIndex/riskReleaseIndex',
            },
            {
              name: "预警总览",
              url: "/oneLevel/riskModuleIndex/overviewIndex/overview",
              commonUrl: '/oneLevel/riskModuleIndex/overviewIndex',
            },
          ]
        },
      ],
      isShowTopMenu: false,
      isLevelAdmin: 1
    };
  },

  created() {
  },
  mounted() {
    config()
    this.$bus.on("isShowTopMenu", v =>{
      this.isShowTopMenu = v
    });
  },

  methods: {
    loginOut() {
      //后财增加退出埋点 20250805
      sensors_sw.logout();
      deleteToken()
      deleteAdminType()
      deleteUserName()
      deleteIsAdmin()
      deleteTeamId()
      this.$router.push('/')
    }
  },
};
</script>

<style lang='scss' scoped>
</style>
